import { useSettings } from "../tools";
import { useCurrentMeeting } from "../contexts/currentMeeting";
import { useEffect } from "react";
import { conferenceLocalStorage } from "conference/tools";
import { TextField } from "@mui/material";
import { FormattedMessage } from "react-intl";

const DisplayNameSetting = () => {
    const settings = useSettings();
    const currentMeeting = useCurrentMeeting();

    const value = settings.displayName;

    useEffect(() => {
        if (value || settings.displayName) return;

        const invitationName = currentMeeting.getDisplayName(currentMeeting.selfInvitation);
        if (invitationName) settings.displayName = invitationName;
        else if (conferenceLocalStorage.profile) settings.displayName = conferenceLocalStorage.profile.name;
    }, []);

    return (
        <TextField
            value={value ?? ""}
            onChange={(ev) => (settings.displayName = ev.target.value)}
            fullWidth
            size="small"
            label={<FormattedMessage id="meetingPage.prepare.displayName" defaultMessage="Display name" />}
            margin="dense"
            required
        />
    );
};

export default DisplayNameSetting;
